import { EmailCopyButton } from './EmailCopyButton';

export const NameCell = ({ name, email }: { name: string; email: string }) => (
  <div className='flex flex-col items-start gap-0.5'>
    <span className='text-sm font-semibold text-gray-700'>{name}</span>
    <EmailCopyButton email={email} />
  </div>
);
